import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import "./admin.css";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = () => {
    logout();
    nav("/admin/login");
  };

  const linkClass = ({ isActive }) => (isActive ? "active" : "");

  return (
    <div className="admin-shell">
      <div className="admin-topbar">
        <div className="admin-brand">YAGNIKA ADMIN</div>
        <nav className="admin-nav">
          <NavLink to="/admin" end className={linkClass} data-testid="nav-dashboard">Dashboard</NavLink>
          <NavLink to="/admin/translations" className={linkClass} data-testid="nav-translations">Translations</NavLink>
        </nav>
        <div className="admin-user">
          <span>{user?.email}</span>
          <button className="admin-logout" data-testid="admin-logout" onClick={doLogout}>Logout</button>
        </div>
      </div>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}
